$shm_hitalama_map_widget_float_chart $shm_hitalama_map_widget_float
	controls /
		<= Chart $shm_hitalama_chart_line
			gap_left <= gap_left
			names <= names /
			labels <= labels /string
			series_y* <= series_y* /
	width_min 200
	height_min 200
	contextmenu_body /
		<= Settings_add $mol_button_minor
			title \Добавить виджет настроек
			click? <=> settings_add? null
		<= Filters_add $mol_pop_over
			align \right_bottom
			Anchor <= Filters_add_anchor $mol_button_minor
				title \Добавить фильтр
			bubble_content /
				<= Filters $mol_list
					sub <= filter_buttons /
						<= Filter_add*0 $mol_button_minor
							title <= filter_name* \
							click? <=> filter_add*? null
		^
	settings_content /
		<= Gap_left_section $mol_view
			sub /
				<= Gap_left_label $mol_text
					text \Отступ слева
				<= Gap_left $mol_number
					value? <=> gap_left? 60
